// @flow
import type { Message } from '../types';
import { CALL_API } from '../middlewares/api';
import * as constants from '../constants/messageConstants';

type _Message = {
    recipient: $PropertyType<Message, 'recipient'>,
    body: $PropertyType<Message, 'body'>
};
type SendMessageAction = {|
    type: typeof constants.SEND_MESSAGE,
    [CALL_API]: {
        method: 'POST',
        endpoint: '/api/message',
        data: _Message
    }
|};

export type MessageAction = SendMessageAction;

export default {
    sendMessage: (message: _Message): SendMessageAction => ({
        type: constants.SEND_MESSAGE,
        [CALL_API]: {
            method: 'POST',
            endpoint: '/api/message',
            data: message
        }
    })
};